import React from 'react';
import PropTypes from 'prop-types';
import { withSize } from 'react-sizeme';
import noop from 'lodash/noop';
import get from 'lodash/get';

import themeable from 'zignal-landscape/lib/themeable';
import CategoryForceGraph from '../CategoryForceGraph';
import {compareClusterNodes} from '../../../../dataUtils';
import GearsIcon from 'zignal-landscape/lib/Icon/GearsIcon';

const SIZE_ME_CONFIG = {
  refreshMode: 'debounce',
  refreshRate: 100
};

class CategoryGraphSection extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      tempHoverId: null,
      mouseActive: false
    };

    this.handleOnMouseOver = this.handleOnMouseOver.bind(this);
    this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);
    this.handleNodeCanvasObject = this.handleNodeCanvasObject.bind(this);
    this.handleNodeVal = this.handleNodeVal.bind(this);
    this.handleDelayTooltip = this.handleDelayTooltip.bind(this);
    this.handleOnNodeHover = this.handleOnNodeHover.bind(this);
    this.setupForceGraphRef = this.setupForceGraphRef.bind(this);
  }

  setupForceGraphRef(el) {
    this.forceGraphRef = el;
  }

  shouldComponentUpdate(nextProps) {
    return (
      this.props.size.width !== nextProps.size.width
      || this.props.tooltip !== nextProps.tooltip
      || this.props.sizeBy !== nextProps.sizeBy
      || compareClusterNodes(this.props.nodes, nextProps.nodes)
    );
  }


  handleOnMouseOver() {
    this.setState({mouseActive: true});
  }

  handleOnMouseLeave() {
    this.props.setGraphHover(null);
    this.setState({mouseActive: false, tempHoverId: null});
  }

  handleNodeCanvasObject(node, ctx, globalScale){
    const { drawNodeToCanvas, sizeBy, hoverMap } = this.props;
    drawNodeToCanvas(node, ctx, globalScale, sizeBy, hoverMap);
  }

  handleNodeVal(node) {
    return get(node, `normalizedSizes[${this.props.sizeBy}]`, node.size);
  }

  handleDelayTooltip(node) {
    const {id: hoverId} = node;
    this.setState({tempHoverId: hoverId});
    this.props.setGraphHover(null);
    setTimeout(() => {
      if (hoverId && hoverId === this.state.tempHoverId && this.state.mouseActive){
        this.props.setGraphHover(node);
      }
    }, 300);
  }

  handleOnNodeHover(node) {
    const { setGraphHover, displayIndex, categoryId, hoverMap: { hoverId } } = this.props;
    const { mouseActive } = this.state;
    if (mouseActive){
      const { id } = node || {};
      if (node && !hoverId || id !== hoverId) {
        /*
         * force-graph 1.51.0 uses '.float-tooltip-kap' for its internal tooltip element
         * (was '.graph-tooltip' in 1.32.x). The element tracks mouse position within the canvas.
         */
        const el = window.$('.float-tooltip-kap')[displayIndex];
        const top = parseFloat(window.$(el).css('top').slice(0, -2));
        const left = parseFloat(window.$(el).css('left').slice(0, -2));
        this.handleDelayTooltip(Object.assign({categoryId, position: {top, left}}, node));
      } else {
        this.setState({ tempHoverId: null });
        setGraphHover(null);
      }
    }
  }

  render() {
    const {styles, nodes, avgAutomationScore, size: { width }, tooltip, sizeBy} = this.props;
    const automationScoreStyle = avgAutomationScore === 'Unknown' ? 'unknownScore' : 'knownScore';

    return (
      <div
        className={styles.CategoryGraphSection}
        onMouseOver={this.handleOnMouseOver}
        onMouseLeave={this.handleOnMouseLeave}
      >
        <div className={styles[automationScoreStyle]}>
          <span>{avgAutomationScore}</span>
          {avgAutomationScore !== 'Unknown' && <GearsIcon width={10} height={10} />}
        </div>
        <CategoryForceGraph
          ref={this.setupForceGraphRef}
          nodes={nodes}
          width={width}
          nodeCanvasObject={this.handleNodeCanvasObject}
          nodeVal={this.handleNodeVal}
          onNodeHover={this.handleOnNodeHover}
          sizeBy={sizeBy}
        />
        {tooltip}
      </div>
    );
  }
}

/**
 * Graphs are displayed on a grid and each one has to set the position of
 * the tooltip to whatever node is hovered. For set the correct left and
 * top position this requires to know where on the grid the component is.
 * Size contains the dynamic width of the component.
 * displayIndex param is for the component at the grid.
 * Grids are always four columns.
 */
CategoryGraphSection.propTypes = {
  styles: PropTypes.object.isRequired,
  size: PropTypes.object.isRequired,
  nodes: PropTypes.array.isRequired,
  sizeBy: PropTypes.string.isRequired,
  setGraphHover: PropTypes.func,
  drawNodeToCanvas: PropTypes.func,
  tooltip: PropTypes.node,
  hoverMap: PropTypes.object,
  displayIndex: PropTypes.number.isRequired,
  categoryId: PropTypes.string.isRequired,
  avgAutomationScore: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

CategoryGraphSection.defaultProps = {
  setGraphHover: noop
};

export default withSize(SIZE_ME_CONFIG)(themeable(CategoryGraphSection));
